import { FC } from "react";
import Collapse from "@material-tailwind/react/components/Collapse";
import Special from "./markets/special";
import { mapSpecialTitle } from "./config";

export type SpecialPriceProps = {
  matchId: string;
  leagueId: string;
  oddsType?: number;
  data?: any;
  isLive?: boolean;
  isLoading?: boolean;
  onClickSpecialPrice?: (data: {
    leagueId: string;
    outcomeId: string;
    marketId: string;
    sp: string;
    matchId: string;
    option: number;
  }) => void;
};

const SpecialPrice: FC<SpecialPriceProps> = ({
  matchId,
  onClickSpecialPrice,
  oddsType = 0,
  leagueId,
  data,
  isLoading = false,
  isLive = false,
}) => {
  return (
    <Collapse className="p-3" open>
      <div className="grid grid-cols-12 gap-2">
        {isLoading && (
          <>
            <div className="col-span-3">
              <Special isLoading isLive={isLive} />
            </div>
            <div className="col-span-3">
              <Special isLoading isLive={isLive} />
            </div>
            <div className="col-span-3">
              <Special isLoading isLive={isLive} />
            </div>
            <div className="col-span-3">
              <Special isLoading isLive={isLive} />
            </div>
          </>
        )}
        {data?.dc && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["dc"]}
              data={data?.dc}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}
        {data?.oe && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["oe"]}
              data={data?.oe}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}
        {data?.tob1st && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["tob1st"]}
              data={data?.tob1st}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.tob && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["tob"]}
              data={data?.tob}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.hwn && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["hwn"]}
              data={data?.hwn}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.awn && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["awn"]}
              data={data?.awn}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.yn && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["yn"]}
              data={data?.yn}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.["ht/ft"] && (
          <div className="col-span-6">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["ht/ft"]}
              data={data?.["ht/ft"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.["ht/ft/oe"] && (
          <div className="col-span-6">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["ht/ft/oe"]}
              data={data?.["ht/ft/oe"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}
        {data?.["1h/ttg"] && (
          <div className="col-span-6">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["1h/ttg"]}
              data={data?.["1h/ttg"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}
        {data?.["ttg"] && (
          <div className="col-span-6">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["ttg"]}
              data={data?.["ttg"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.["1h/cr"] && (
          <div className="col-span-12">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["1h/cr"]}
              data={data?.["1h/cr"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.["2h/cr"] && (
          <div className="col-span-12">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["2h/cr"]}
              data={data?.["2h/cr"]}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.cr && (
          <div className="col-span-12">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["cr"]}
              data={data?.cr}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.hto && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["hto"]}
              data={data?.hto}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}

        {data?.ato && (
          <div className="col-span-3">
            <Special
              matchId={`${matchId}`}
              leagueId={`${leagueId}`}
              oddsType={oddsType}
              title={mapSpecialTitle["ato"]}
              data={data?.ato}
              onClick={onClickSpecialPrice}
              isLive={isLive}
            />
          </div>
        )}
      </div>
    </Collapse>
  );
};

export default SpecialPrice;
